{
  "page_count": "из {n, plural, one{# стр.} other{# стр.}}"
}
